<div>
    <app-participants></app-participants>
</div>
